module.exports = __webpack_public_path__ + "static/media/background.88a300d4.jpg";